'use client'

import * as React from 'react'

import { useTenant } from '@rewardops/auth'

import { useApi } from '~/components/hooks/use-api'
import ResponsiveComponent from '~/components/responsive-component'
import { AgentImpersonationBanner } from './agent-impersonation-banner'
import { DesktopMainNav } from './desktop-nav-bar'
import { DesktopStackedNavBar } from './desktop-stacked-nav-bar'
import { MobileMainNav } from './mobile-nav-bar'

export function MainNavBar() {
  const { api } = useApi()
  const tenant = useTenant()
  const { data: categories, isLoading } = api.categories.getSummarized.useQuery(
    undefined,
    {
      enabled: tenant?.flags?.categories,
    },
  )

  const mobileComponent = (
    <MobileMainNav categories={categories} isLoading={isLoading} />
  )

  const desktopComponent = tenant?.stackedNavBarLinks?.[0] ? (
    <DesktopStackedNavBar categories={categories} isLoading={isLoading} />
  ) : (
    <DesktopMainNav categories={categories} isLoading={isLoading} />
  )

  return (
    <header className="sticky top-0 z-40">
      <ResponsiveComponent
        mobileComponent={mobileComponent}
        desktopComponent={desktopComponent}
      />
      <AgentImpersonationBanner />
    </header>
  )
}
